"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createrSearchMappingsEndpointRequest = void 0;
function createrSearchMappingsEndpointRequest(parameters) {
    return {
        method: 'GET',
        endpoint: `search/mappings`,
        params: {
            term: parameters.term,
        },
    };
}
exports.createrSearchMappingsEndpointRequest = createrSearchMappingsEndpointRequest;
